// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36279b28","732":"5168bdff"}[chunkId] + ".chunk.js";
};